import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit
} from '@angular/core'
import { sortBy, get, startCase } from 'lodash';
import { formatDistanceToNow } from 'date-fns';
import { parseDate } from '../../utils/date.util';

@Component({
  selector: 'dataset-status-modal',
  templateUrl: './dataset-status-modal.component.html',
  styleUrls: ['dataset-status-modal.component.less'],
  standalone: false
})
export class DatasetStatusModalComponent implements OnInit {
  @Input() datasets = []

  statusColorMapping = {
    'failure': {
      color: 'red',
      displayName: 'Unsuccessful',
    },
    'warning': {
      color: 'yellow',
      displayName: 'Warning',
    },
    'success': {
      color: 'green',
      displayName: 'Success',
    },
    'running': {
      color: 'blue',
      displayName: 'Running',
    },
  }

  ngOnInit() {
    this.datasets = sortBy(this.datasets, dataset => dataset.meta?.display?.name || dataset.name);
    this.datasets.forEach(dataset => {
      dataset.jobs = sortBy(dataset.jobs || [], 'name');
    });
  }

  relativeDate(date) {
    return formatDistanceToNow(parseDate(date), { addSuffix: true })
  }

  statusColor(status) {
    return get(this.statusColorMapping, `${status}.color`)
  }

  statusName(status) {
    return get(this.statusColorMapping, `${status}.displayName`) || startCase(status)
  }
}
